<script>
  import { isValidEmail, notEmpty } from '../helpers/form-validation.js'
  import AuthContainer from '../auth/AuthContainer.svelte'
  import TextInput from '../components/TextInput.svelte'
  import Button from '../components/Button.svelte'
  import Modal from '../components/Modal.svelte'
  import Privacy from '../components/Privacy.svelte'
  import Terms from '../components/Terms.svelte'
  import { t } from '../i18n/i18n'

  import { snackBarStore, modalStore } from '../state/store'

  let pending = false

  let form = {
    name: '',
    email: '',
    origin: window.location.origin
  }

  $: emailValid = isValidEmail(form.email)
  $: formValid = emailValid && notEmpty(form.name)

  const submitForm = async () => {
    pending = true
    setTimeout(() => {
      pending = false
    }, 2000);
    try {
      const response = await fetch('/api/register', {
        method: 'POST',
        body: JSON.stringify({
          ...form
        })
      })
      const data = await response.json()
      if (response.ok) {
        snackBarStore.set({ message: `${$t.complete_registration} ${form.email}` , type: 'success' })
      } else {
        throw data.message || new Error( $t.something_wrong)
      }
    } catch (error) {
      snackBarStore.set({ message: error, type: 'error' })
    }
  }
  

</script>

<style>

  div {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  p {
    margin-top: 2rem;
    font-size: 1.4rem;
  }

</style>

<AuthContainer>
  <div>
    <h1>{$t.register}</h1>
    <p>{$t['Step']} 1</p>
  </div>
  <form on:submit|preventDefault={submitForm}>
    <TextInput
      id='name'
      label='{$t['Company Name']}'
      validityMessage='{$t['Please enter a contact name']}'
      on:input={event => (form.name = event.target.value)}
      value="{form.name}" />
    <TextInput
      id='email'
      label='{$t['Primary Email']}'
      valid={emailValid}
      validityMessage='{$t.valid_email}'
      type='email'
      value={form.email}
      on:input={event => (form.email = event.target.value)} />

    <Button size='full' type="submit" disabled={!formValid || pending}>
      {$t['Get Started']}
    </Button>

  </form>
  <p class='g-center'>{$t.register_agree} <button on:click={() => modalStore.toggle('terms')} class='g-unbutton'>{$t.terms_conditions_and_privacy}</button></p>
  <Modal name="terms" large='true'>
    <h2 slot='header'>{$t.terms_conditions_privacy}</h2>
    <section>
      <Privacy></Privacy>
      <Terms></Terms>
    </section>
  </Modal>
</AuthContainer>
